import type { EditorState } from 'draft-js';
import type { FC } from 'types/react';

import { isStyleApplied } from '../../helpers/is-style-applied';
import { UnderlineIcon } from './static_assets';
import { Button } from './styles';

interface Props {
    editorState: EditorState;
    onClick: () => void;
}

export const UnderlineButton: FC<Props> = ({ editorState, onClick }) => (
    <Button $isActive={isStyleApplied('UNDERLINE', editorState)} onClick={onClick}>
        <UnderlineIcon />
    </Button>
);
